<template>
  <div>
    <fancy-button :text="getText"/>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";
import FancyButton from "@/components/generic/FancyButton";

export default {
  name: 'form-actions',
  mixins: [AbstractField],
  components: {
    FancyButton
  },
  computed: {
    getText() {
      if(this.fieldAttributes.hasOwnProperty('#submit_label')) {
        return this.fieldAttributes['#submit_label']
      } else {
        return this.$t('register.submit');
      } 
    }
  }
}
</script>
